<template>
    <div class="custom-select--item" :class="{selected: isSelected}">
        <img v-if="option.icon" class="custom-select--icon" :src="getIconUrl" :alt="`${option.plan_name} icon`">
        <div class="custom-select--content">
            <p v-if="option.pre_heading" class="custom-select--pre-heading">{{option.pre_heading}}</p>
            <p v-if="option.plan_name" class="custom-select--heading">{{option.plan_name}}{{productPrice}}</p>
            <p v-if="option.post_heading" class="custom-select--post-heading">{{option.post_heading}}</p>
        </div>
        <img v-if="isSelected" class="custom-select--select-indicator" src="@/assets/images/decoration/icons/Check.png" alt="Selected indicator icon">
    </div>
</template>

<script>
export default {
    name: 'CustomSelectItem',
    props: {
        option: {
            type: Object,
            require: true,
        },
        selectedOption: {
            type: Object,
            require: true,
        },
        trackBy: {
            type: String,
            required: true,
        },
        width: {
            type: [Number, String],
            default: 'auto',
        },
        height: {
            type: [Number, String],
            default: 'auto',
        },
        fillColor: {
            type: String,
            default: '#262323',
        },
    },
    computed: {
        getIconUrl() {
            return require(`@/assets/images/pages/checkout/${this.getIconName}`);
        },
        isSelected() {
            return this.selectedOption[this.trackBy] === this.option[this.trackBy];
        },
        getIconName() {
            let iconName = this.option.icon.split('.');
            return this.isSelected ? `${iconName[0]}-selected.${iconName[1]}` : this.option.icon;
        },
        currency() {
            return this.$store.getters['localisation/getCurrency'];
        },
        productPrice() {
            return this.option.price ? ` - ${this.currency}${Number(this.option.price)}` : '';
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-select {
    &--item {
        display: flex;
        width: 100%;
        margin: 10px auto;
        align-items: center;
        border: 1px solid #CECECE;
        position: relative;
        border-radius: 4px;
        padding: 20px 10px;
        &:hover {
            cursor: pointer;
        }
    }
    &--icon {
        width: 90px;
        margin-right: 20px;
        padding: 10px;
    }
    &--select-indicator {
        position: absolute;
        top: 5px;
        right: 5px;
    }
    &--pre-heading {
        font-size: 11px;
        line-height: 14px;
        font-weight: 400;
        margin: 0;
    }
    &--post-heading {
        font-size: 12px;
        line-height: 14px;
        margin: 0;
    }
    &--heading {
        font-size: 18px;
        line-height: 30px;
        margin: 0;
    }
}
.selected {
    border: 2px solid #52755C;
    & .custom-select--pre-heading {
        color: #63A75E;
    }
    & .custom-select--post-heading, & .custom-select--heading {
        color: #52755C;
    }
}
</style>
